import React, { Component } from 'react'
import { connect } from 'react-redux'
import GoogleMap from 'components/common/Maps/Map'
import { setMapPosition } from 'reducers/seaLice/reducer'
import MarkerList from './MarkerList/MySitesMarkerList'
import MapLoader from './MapManipulation/MySitesMapLoader'
import MarkerInfo from './MarkerList/MarkerInfo'

const MapRef = React.createRef()

class MySitesMap extends Component {
  constructor(props) {
    super(props)
    this.mapChangeTimeout = null
  }

  onMapPositionChanged = () => {
    clearTimeout(this.mapChangeTimeout)
    this.mapChangeTimeout = setTimeout(this.saveMapPosition, 500)
  }

  saveMapPosition = () => {
    if (MapRef.current !== null) {
      this.props.setMapPosition({
        mapZoom: MapRef.current.getZoom(),
        mapCenter: MapRef.current.getCenter().toJSON(),
      })
    }
  }

  shouldComponentUpdate(nextProps) {
    return this.props.mapPosition === nextProps.mapPosition
  }

  render() {
    const { mapPosition, hiddenMarkerInfo } = this.props
    const mapZoom = mapPosition ? mapPosition.get('mapZoom') : undefined
    const mapCenter = mapPosition ? mapPosition.get('mapCenter') : undefined

    return (
      <div className="map-container">
        <GoogleMap
          mapRef={MapRef}
          mapZoom={mapZoom}
          mapCenter={mapCenter}
          onCenterChanged={this.onMapPositionChanged}
          onZoomChanged={this.onMapPositionChanged}>
          <MarkerList />
          {!hiddenMarkerInfo && <MarkerInfo />}
        </GoogleMap>
        <MapLoader mapRef={MapRef} />
      </div>
    )
  }
}

export default connect(
  state => ({
    mapPosition: state.getIn(['seaLice', 'mapPosition']),
  }),
  { setMapPosition },
)(MySitesMap)
